import { merge } from 'lodash';

/**
 * Marker objects can directly alter the DOM using primitive shapes and lines
 * and are intended to be managed via Indicator objects
 */
class Marker {
	constructor(params, panel) {
		this.panel = panel;
		this.params = this._getParams(params);
	}

	/**
	 * A wrapper for getDefaultParams
	 * @return {object}
	 */
	_getParams(params) {
		return merge({}, this.getDefaultParams(), params);
	}

	/**
	 * return the default params for this type of Marker
	 * @return {object}
	 */
	getDefaultParams() {
		throw new Error('Required Marker method not found');
	}

	/**
	 * calculate dynamic bar width based on data period and panel domain
	 * (method used by more than one marker subclass so it lives here)
	 * @param {Panel} panel
	 * @return {int}
	 */
	getBarWidth(panel, min = null, max = null) {
		if (!min && !max) [min, max] = panel.xAxis.primaryScale.domain();
		const { width } = panel.size;
		let len = max - min;

		switch (panel.core.params.dataPeriod) {
			case 'Year':
				len /= 365;
				break;
			case 'Month':
				len /= 15;
				break;
			case 'Week':
				len /= 3;
				break;
			case 'Day':
				break;
			case 'Hour':
				len /= 30;
				break;
			case 'Minute':
				len /= panel.core.params.dataInterval
					? panel.core.params.dataInterval
					: 1;
				break;
			default:
				break;
		}

		const w0 = Math.min(15, Math.max(0, width / len / 2 / 2));

		return w0 < 0.25 ? 0 : w0;
	}

	/** Update DOM elements using primitive shapes and lines */
	render() {
		throw new Error('Required Marker method not found');
	}
}

export default Marker;
